import CheckIcon from "@mui/icons-material/Check";
import { Box, Grid, MenuItem, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef } from "react";
import { allIcons } from "../../../assets";
import AppContainer from "../../../components/AppContainer";
import GlobalButton from "../../../components/CustomButton";
import CustomDropDown from "../../../components/CutomDropDown";
import Label from "../../../components/Label";
import TextInput from "../../../components/TextInputs";
import appcolors from "../../../constants/Colors";
import globalStyle from "../../../globalStyle";
import { calculateFinalAmount, generateTimeOptions } from "../../../utils";

function SingleService(props) {
  const {
    inputValue,
    category,
    finalValue,
    handleInputChange,
    isReminderSelected,
    setIsReminderSelected,
    editData,
    handleBack,
    setFinalValue,
    handleCreateService,
    setImages,
  } = props;

  const imageBtnRef = useRef();

  useEffect(() => {
    let valuessss = calculateFinalAmount(
      inputValue?.tax,
      inputValue?.price,
      inputValue?.discount
    );
    setFinalValue(valuessss);
  }, [inputValue]);

  const durationData = generateTimeOptions();
  console.log(durationData, "durationDatadurationDatadurationData");

  return (
    <AppContainer
      primaryHeading={"Basic info"}
      secondaryHeading={"Add a service name and choose the service type."}
      showBackButton
      handleBack={handleBack}
      childrenProps={{
        sx: {
          padding: { xs: "10px 20px", md: "20px 50px" },
          paddingBottom: "50px !important",
        },
      }}
    >
      <Typography my={1} variant="h1" fontSize={"1.125rem"} fontWeight={600}>
        Basic information
      </Typography>

      <Grid container spacing={2} my={1}>
        <Grid item xs={12} md={4}>
          <Label labelText="Service name" required />
          <TextInput
            value={inputValue?.name}
            name="name"
            onChange={handleInputChange}
            styleProps={globalStyle.textField}
            placeholder={"e.g hair cut"}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Label labelText="Category" required />
          <CustomDropDown
            name="categoryID"
            value={inputValue?.categoryID}
            onChange={handleInputChange}
            size={"small"}
          >
            {category.map((item, index) => {
              return (
                <MenuItem key={index} value={item._id}>
                  {item?.name}
                </MenuItem>
              );
            })}
          </CustomDropDown>
        </Grid>

        <Grid item xs={12}>
          <Label labelText="Service description" required />
          <TextInput
            onChange={handleInputChange}
            value={inputValue?.description}
            name="description"
            styleProps={globalStyle.textField}
            placeholder={"Add your activity description here"}
            multiline
            rows={3}
          />
        </Grid>
        <Grid item xs={12}>
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
            flexWrap={"wrap"}
          >
            <Label labelText="Aftercare description" required />
            <Label
              labelText="NOTE: This message will send it to client after taking service"
              labelProps={{ color: appcolors.primary }}
            />
          </Stack>
          <TextInput
            onChange={handleInputChange}
            value={inputValue?.afterCare}
            name="afterCare"
            styleProps={globalStyle.textField}
            placeholder={"Add your activity description here"}
            multiline
            rows={3}
          />
        </Grid>
      </Grid>

      <Typography
        mt={3}
        mb={2}
        variant="h1"
        fontSize={"1.125rem"}
        fontWeight={600}
      >
        Pricing & Duration
      </Typography>

      <Grid container spacing={2} my={1}>
        <Grid item xs={12} md={4}>
          <Label labelText="Duration" required />
          <CustomDropDown
            value={inputValue?.duration}
            name="duration"
            onChange={handleInputChange}
            size={"small"}
          >
            {durationData?.map((item) => {
              return <MenuItem value={item?.value}>{item?.label}</MenuItem>;
            })}
          </CustomDropDown>
        </Grid>

        <Grid item xs={12} md={4}>
          <Label labelText="Price" required />
          <TextInput
            onChange={handleInputChange}
            value={inputValue?.price}
            name="price"
            styleProps={globalStyle.textField}
            placeholder={"SAR"}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <Label labelText="Tax % (Optional)" required />
          <TextInput
            onChange={handleInputChange}
            name="tax"
            value={inputValue.tax}
            styleProps={globalStyle.textField}
            placeholder={"13%"}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Label labelText="Discount (in %)" required />
          <TextInput
            onChange={(e) => {
              const value = e.target.value;
              if (value === "" || (value >= 1 && value <= 100)) {
                handleInputChange(e); // Only allow valid values
              }
            }}
            value={inputValue?.discount}
            name="discount"
            styleProps={globalStyle.textField}
            placeholder="10%"
            type="number"
            min="1" // Minimum value
            max="100" // Maximum value
          />
        </Grid>
      </Grid>

      <Typography
        my={3}
        variant="h1"
        fontSize={"1.3rem"}
        fontWeight={800}
        textAlign={"right"}
      >
        Final Cost: {finalValue ? finalValue : 0} SAR
      </Typography>
      {/* <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Label labelText="Extra Cost /houre price" required />
          <TextInput
            onChange={handleInputChange}
            value={inputValue?.extraPerHour}
            name="extraPerHour"
            styleProps={globalStyle.textField}
            placeholder={"SAR"}
          />
        </Grid>
      </Grid> */}

      <Typography
        mt={3}
        mb={2}
        variant="h1"
        fontSize={"1.125rem"}
        fontWeight={600}
      >
        Notification setting
      </Typography>

      <Stack gap={1} direction={"row"} alignItems={"center"} mb={1}>
        <Box
          onClick={() => setIsReminderSelected(!isReminderSelected)}
          height={20}
          width={20}
          bgcolor={isReminderSelected ? "primary.main" : "#FFF"}
          borderRadius={"3px"}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          {!isReminderSelected && (
            <img
              src={allIcons.uncheckSquareIcon}
              style={{ height: "100%", width: "100%" }}
            />
          )}
          {isReminderSelected && (
            <CheckIcon htmlColor="#FFF" fontSize={"12px"} />
          )}
        </Box>
        <Label
          labelText="Reminder for booking"
          labelProps={{ marginBottom: 0 }}
        />
      </Stack>

      {isReminderSelected && (
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Label labelText="Reminder before*" required />
            <CustomDropDown
              value={inputValue?.reminderBefore}
              name="reminderBefore"
              onChange={handleInputChange}
              size={"small"}
            >
              <MenuItem value={"15"}>15 min</MenuItem>
              <MenuItem value={"30"}>30 min</MenuItem>
              <MenuItem value={"45"}>45 min</MenuItem>
              <MenuItem value={"60"}>60 min</MenuItem>
            </CustomDropDown>
          </Grid>
          <Grid item xs={12} md={8}>
            <Label labelText="Message" required />
            <TextInput
              onChange={handleInputChange}
              value={inputValue?.reminderMessage}
              name="reminderMessage"
              styleProps={globalStyle.textField}
              placeholder={"e.g please come on time"}
            />
          </Grid>
        </Grid>
      )}

      <Stack
        mt={4}
        gap={2}
        direction={"row"}
        justifyContent={"flex-end"}
        alignItems={"center"}
      >
        <GlobalButton
          variant={"outlined"}
          btnText={"Cancel"}
          styleProps={{ width: { xs: "100%", sm: 150 }, height: 45 }}
          handleClickBtn={handleBack}
        />
        <GlobalButton
          variant={"contained"}
          btnText={editData?.type !== "add" ? "Update" : "Save"}
          handleClickBtn={() => handleCreateService(editData)}
          styleProps={{ width: { xs: "100%", sm: 150 }, height: 45 }}
        />
      </Stack>
    </AppContainer>
  );
}

export default SingleService;
